import React, { Component } from 'react';
import PropTypes from 'prop-types';
import debounce from 'lodash.debounce';
import isEqual from 'lodash.isequal';

import FilterFormWithSubmit from './FilterFormWithSubmit';
import FilterButton from 'admin-on-rest/lib/mui/list/FilterButton';
import removeEmpty from 'admin-on-rest/lib/util/removeEmpty';
import withPermissionsFilteredChildren from 'admin-on-rest/lib/auth/withPermissionsFilteredChildren';

export class FilterWithSubmit extends Component {
    constructor(props) {
        super(props);
        this.filters = this.props.filterValues;
    }

    componentWillReceiveProps(nextProps) {
        this.filters = nextProps.filterValues;
    }

    componentWillUnmount() {
        if (this.props.setFilters) {
            this.setFilters.cancel();
        }
    }

    setFilters = debounce(filters => {
        if (!isEqual(filters, this.filters)) {
            // fix for redux-form bug with onChange and enableReinitialize
            const filtersWithoutEmpty = removeEmpty(filters);
            this.props.setFilters(filtersWithoutEmpty);
            this.filters = filtersWithoutEmpty;
        }
    }, this.props.debounce);

    renderButton() {
        const {
            resource,
            children,
            showFilter,
            displayedFilters,
            filterValues,
        } = this.props;
        return (
            <FilterButton
                key="filter-button"
                resource={resource}
                filters={React.Children.toArray(children)}
                showFilter={showFilter}
                displayedFilters={displayedFilters}
                filterValues={filterValues}
            />
        );
    }

    renderForm() {
        const {
            resource,
            children,
            filterButton,
            hideFilter,
            displayButton,
            displayedFilters,
            filterValues,
            updateOnChange
        } = this.props;
        return (
            <FilterFormWithSubmit
                resource={resource}
                filters={React.Children.toArray(children)}
                hideFilter={hideFilter}
                displayButton={displayButton}
                displayedFilters={displayedFilters}
                initialValues={filterValues}
                setFilters={this.setFilters}
                filterButton={filterButton}
                updateOnChange={updateOnChange}
            />
        );
    }

    render() {
        return this.props.context === 'button'
            ? this.renderButton()
            : this.renderForm();
    }
}

FilterWithSubmit.propTypes = {
    children: PropTypes.node,
    context: PropTypes.oneOf(['form', 'button']),
    debounce: PropTypes.number.isRequired,
    displayButton: PropTypes.bool,
    displayedFilters: PropTypes.object,
    filterButton: PropTypes.string,
    filterValues: PropTypes.object,
    hideFilter: PropTypes.func,
    setFilters: PropTypes.func,
    showFilter: PropTypes.func,
    resource: PropTypes.string.isRequired,
    updateOnChange: PropTypes.bool,
};

FilterWithSubmit.defaultProps = {
    debounce: 500,
    displayButton: true,
    updateOnChange: false
};

export default withPermissionsFilteredChildren(FilterWithSubmit);



// WEBPACK FOOTER //
// ./src/Fuse/admin/FilterWithSubmit.js